export default "__VITE_ASSET__ZGYw$lbF__"